// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@awc/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { rfqConfirmationDetailsStyles } from "@awc/Overrides/Widgets/RfqConfirmation/RfqConfirmationDetails";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { mergeWithCss } from "@awc/XDL/Utilities";
import { GridItemProps } from "@insite/mobius/GridItem";
import { css } from "styled-components";

const gridItemValue: GridItemProps = { width: [12, 6, 6, 4, 4] };

rfqConfirmationDetailsStyles.detailsGridContainer = {
    gap: 0,
    css: css`
        margin-bottom: 20px;
    `,
};

rfqConfirmationDetailsStyles.jobNameGridItem =
    rfqConfirmationDetailsStyles.salesRepGridItem =
    rfqConfirmationDetailsStyles.statusGridItem =
    rfqConfirmationDetailsStyles.dateGridItem =
    rfqConfirmationDetailsStyles.customerGridItem =
    rfqConfirmationDetailsStyles.shipToGridItem =
    rfqConfirmationDetailsStyles.notesGridItem =
    {
        ...gridItemValue,
    };

rfqConfirmationDetailsStyles.dateLabelText = {
    ...mergeWithCss(xOrderInformationStyles.labelWithDots, {
        size: fontConfig.fontSize.regular,
        weight: fontConfig.weight.bold,
        css: css`
            margin-bottom: 4px;
            margin-right: 5px;
        `,
    }),
};

rfqConfirmationDetailsStyles.dateValueText = {
    color: "primary",
    size: fontConfig.fontSize.regular,
    weight: fontConfig.weight.regular,
}


rfqConfirmationDetailsStyles.customerHeadingAndText =
    rfqConfirmationDetailsStyles.shipToHeadingAndText =
    rfqConfirmationDetailsStyles.notesHeadingAndText =
    rfqConfirmationDetailsStyles.jobNameHeadingAndText =
    rfqConfirmationDetailsStyles.salesRepHeadingAndText =
    rfqConfirmationDetailsStyles.statusHeadingAndText =
    {
        ...mergeWithCss(xOrderInformationStyles.headingAndTextStyles, {
            heading: {
                size: fontConfig.fontSize.regular,
                weight: fontConfig.weight.bold,
                css: css`
                    margin-right: 5px;
                `,
            },
            text: {
                size: fontConfig.fontSize.regular,
            }
        }),
    }

